/* src/app/shared-components/mb-card/mb-card.component.scss */
:host ::ng-deep {
  display: block;
}
:host ::ng-deep article {
  display: flex;
  flex-direction: column;
  background-color: rgb(255, 255, 255);
  box-shadow: 0 7px 14px 0 rgba(59, 65, 94, 0.1), 0 3px 6px 0 rgba(0, 0, 0, 0.07);
  padding: 2rem;
  margin: 0 1rem 2rem 1rem;
  border-radius: 0.75rem;
}
:host ::ng-deep article > footer {
  padding: 2rem;
  margin: 0 -2rem -2rem -2rem;
  background-color: rgba(215, 225, 238, 0.25);
}
/*# sourceMappingURL=mb-card.component.css.map */
